import { getList } from '../api';
import { queryOptions } from '@tanstack/react-query'
import { Search } from '../schemas/search';


interface SearchQueryType {
    key?: string
    search: Search
    enabled?: boolean
}

export function searchQueryOptions({ key, search, enabled = false }: SearchQueryType) {
    return queryOptions({
        queryKey: [key, search],
        queryFn: () => getList(search),
        enabled
    })
}
